// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import {
	AcademicYear,
	ClassYear,
	Country,
	EnrollmentApplication,
	EnrollmentApplicationStudent,
	EnrollmentApplicationStudentEnglishLanguageFluency,
	EnrollmentApplicationStudentNameOrder,
	Language,
	Student,
} from "../../../Utilities";
import { EnrollmentApplicationStudentSchoolFormValues } from "../EnrollmentApplicationStudentSchool";

export type Base = {
	imageKey: EnrollmentApplicationStudent["imageKey"];
	imageContentType: EnrollmentApplicationStudent["imageContentType"];
	givenName: EnrollmentApplicationStudent["givenName"];
	middleName: EnrollmentApplicationStudent["middleName"];
	familyName: EnrollmentApplicationStudent["familyName"];
	nameOrder: EnrollmentApplicationStudent["nameOrder"] | null;
	dateOfBirth: EnrollmentApplicationStudent["dateOfBirth"] | null;
	gender: EnrollmentApplicationStudent["gender"];
	englishLanguageFluency: EnrollmentApplicationStudent["englishLanguageFluency"] | null;
	questionnaireActivities: EnrollmentApplicationStudent["questionnaireActivities"];
	questionnaireHasPsychTreatment: EnrollmentApplicationStudent["questionnaireHasPsychTreatment"];
	questionnairePsychTreatmentDescription: EnrollmentApplicationStudent["questionnairePsychTreatmentDescription"];
	questionnaireHasSpecialNeeds: EnrollmentApplicationStudent["questionnaireHasSpecialNeeds"];
	questionnaireSpecialNeedsDescription: EnrollmentApplicationStudent["questionnaireSpecialNeedsDescription"];
	questionnaireHasBehaviors: EnrollmentApplicationStudent["questionnaireHasBehaviors"];
	questionnaireBehaviorsDescription: EnrollmentApplicationStudent["questionnaireBehaviorsDescription"];
	questionnaireDescription: EnrollmentApplicationStudent["questionnaireDescription"];
	questionnaireAdditionalInformation: EnrollmentApplicationStudent["questionnaireAdditionalInformation"];
	academicYearID: AcademicYear["id"] | null;
	classYearID: ClassYear["id"] | null;
	currentClassYearID: ClassYear["id"] | null;
	enrollmentApplicationID: EnrollmentApplication["id"] | null;
	languageIDs: Language["id"][];
	nationalityIDs: Country["id"][];
	studentID: Student["id"] | null;
};

export type Create = Base & {
	enrollmentApplicationStudentSchools: EnrollmentApplicationStudentSchoolFormValues.CreateInEnrollmentApplicationStudent[];
};

export type CreateRequiredKey = Extract<
	keyof Create,
	"givenName" | "familyName" | "dateOfBirth" | "academicYearID" | "classYearID" | "enrollmentApplicationID"
>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	imageKey: "",
	imageContentType: "",
	givenName: "",
	middleName: "",
	familyName: "",
	nameOrder: null,
	dateOfBirth: null,
	gender: "",
	englishLanguageFluency: null,
	questionnaireActivities: "",
	questionnaireHasPsychTreatment: false,
	questionnairePsychTreatmentDescription: "",
	questionnaireHasSpecialNeeds: false,
	questionnaireSpecialNeedsDescription: "",
	questionnaireHasBehaviors: false,
	questionnaireBehaviorsDescription: "",
	questionnaireDescription: "",
	questionnaireAdditionalInformation: "",
	academicYearID: null,
	classYearID: null,
	currentClassYearID: null,
	enrollmentApplicationID: null,
	enrollmentApplicationStudentSchools: [],
	languageIDs: [],
	nationalityIDs: [],
	studentID: null,
};

export type Detail = Base & {
	name: EnrollmentApplicationStudent["name"];
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const englishLanguageFluencyOptions = [
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.A1 },
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.A2 },
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.B1 },
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.B2 },
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.C1 },
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.C2 },
	{ value: EnrollmentApplicationStudentEnglishLanguageFluency.NoKnowledge },
];

export const nameOrderOptions = [
	{ value: EnrollmentApplicationStudentNameOrder.FamilyGiven },
	{ value: EnrollmentApplicationStudentNameOrder.GivenFamily },
];

export type CreateInEnrollmentApplication = Omit<Create, "enrollmentApplicationID">;

export type CreateInEnrollmentApplicationRequiredKey = Exclude<CreateRequiredKey, "enrollmentApplicationID">;

export type CreateInEnrollmentApplicationSubset<
	K extends keyof CreateInEnrollmentApplication = keyof CreateInEnrollmentApplication,
> = Pick<CreateInEnrollmentApplication, CreateInEnrollmentApplicationRequiredKey | K>;

export const blankItemInEnrollmentApplication: CreateInEnrollmentApplication = omitKeys(initialCreate, [
	"enrollmentApplicationID",
]);
